import GTMProvider from './GTMProvider';
import GTMClickListener from './GTMClickListener';


const GTMWrapper = ({ children }: any) => {
  return (
    <>
      <GTMProvider />
      <GTMClickListener />
      {children}
    </>
  );
};

export default GTMWrapper;
